import { CalendarIcon, SendAgainIcon } from "@/assets";
import { CustomModal } from "@/components/custom-modal";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  DialogClose,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import { formattedDate, formattedTime } from "@/lib/helper";

import { getSingleNotifications } from "@/services/Settings.service";
import { useInfiniteQuery } from "@tanstack/react-query";
import { ChevronLeft, Loader2 } from "lucide-react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { VscEye } from "react-icons/vsc";
const Notification = ({ id }) => {
  const {
    data,
    isLoading,
    isFetching,
    refetch,
    hasNextPage,
    fetchNextPage,
    error,
  } = useInfiniteQuery({
    queryKey: ["notifications", id],
    queryFn: async ({ pageParam = 1 }) =>
      await getSingleNotifications(pageParam, id),
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.length === 0) return undefined;
      return pages.length + 1;
    },
    refetchIntervalInBackground: true,
    refetchOnMount: "always",
  });

  const dataArr = data?.pages?.map((page) => page.data.data.data).flat();
  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center  w-full">
          <Loader2 className="animate-spin text-2xl text-center" />
        </div>
      ) : (
        <div className="grid lg:grid-cols-3 gap-4">
          {dataArr?.map((item) => (
            <Card
              className="flex flex-col gap-4 px-6 py-5 bg-background"
              key={item?.id}
            >
              <CardHeader className="flex flex-row items-center justify-between w-full p-0">
                <CardTitle className="text-sm font-normal capitalize text-primary-3">
                  {item?.message?.push?.title}
                </CardTitle>

                <Popover>
                  <PopoverTrigger>
                    <Button variant="ghost" className="h-0 px-1 py-2">
                      <BsThreeDotsVertical className="text-primary-3" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="flex flex-col items-start gap-2 w-fit">
                    <CustomModal
                      button={
                        <Button variant="ghost" className="h-0 px-1 py-2">
                          <VscEye /> View More
                        </Button>
                      }
                      size="sm"
                    >
                      <div className="flex flex-col gap-4 px-6 pt-5">
                        <DialogHeader className="flex flex-row items-center justify-between w-full p-0">
                          <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                            {item?.message?.push?.title}
                          </DialogTitle>
                        </DialogHeader>
                        <p className="text-xs text-gray-80 line-clamp-2">
                          {item?.message?.push?.message}
                        </p>
                        <div>
                          <Separator
                            orientation="horizontal"
                            className="h-[1px] bg-border"
                          />

                          <div className="flex gap-4 p-0 pt-4 text-gray-60">
                            <div className="flex items-center gap-2">
                              <CalendarIcon />
                              <span className="text-xs text-gray-60">
                                {formattedDate(item?.createdAt)}{" "}
                                {formattedTime(item?.createdAt)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <DialogFooter className="px-6 py-3 border-t-[1px] flex flex-row justify-between items-center">
                        <DialogClose asChild>
                          <Button
                            type="button"
                            variant="ghost"
                            className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
                          >
                            <ChevronLeft /> Go Back
                          </Button>
                        </DialogClose>
                        <Button
                          type="button"
                          variant="outline"
                          className=" h-12 rounded-[10px] p-[8px 12px] bg-transparent border-primary border-[1px] text-primary hover:text-primary"
                        >
                          <SendAgainIcon />
                          Send Again
                        </Button>
                      </DialogFooter>
                    </CustomModal>
                    <Button
                      variant="ghost"
                      className="h-0 px-1 py-2 text-primary"
                    >
                      <SendAgainIcon />
                      Send Again
                    </Button>
                  </PopoverContent>
                </Popover>
              </CardHeader>
              <CardContent className="p-0">
                <p className="text-xs text-gray-80 line-clamp-2">
                  {item?.message?.push?.message}
                </p>
              </CardContent>
              <div>
                <Separator
                  orientation="horizontal"
                  className="h-[1px] bg-border"
                />

                <CardFooter className="flex-row gap-4 p-0 pt-4 text-gray-60">
                  <div className="flex items-center gap-2">
                    <CalendarIcon />
                    <span className="text-xs text-gray-60">
                      {formattedDate(item?.createdAt)}{" "}
                      {formattedTime(item?.createdAt)}
                    </span>
                  </div>
                </CardFooter>
              </div>
            </Card>
          ))}
        </div>
      )}
    </>
  );
};

export default Notification;
